import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const newsItems = [
  { id: 1, date: '2026.04.21', category: '会社情報', categoryColor: 'bg-emerald-100 text-emerald-700', title: '代表者変更に伴う会社情報更新のお知らせ', body: '代表者変更に伴い、当社サイト上の会社情報を更新いたしました。今後ともよろしくお願いいたします。', isImportant: true },
  { id: 2, date: '2026.03.15', category: 'サービス', categoryColor: 'bg-cyan-100 text-cyan-700', title: 'Webサービス運営プランをリニューアルしました', body: 'お客様のニーズに合わせた新しい料金プランをご用意しました。ライト・スタンダード・プレミアムの3プランから選べます。', isImportant: false },
  { id: 3, date: '2026.02.28', category: 'お知らせ', categoryColor: 'bg-teal-100 text-teal-700', title: '株式会社Ocean 公式サイトをオープンしました', body: '株式会社Oceanの公式コーポレートサイトをオープンいたしました。今後ともよろしくお願いいたします。', isImportant: false },
  { id: 4, date: '2026.02.10', category: 'サービス', categoryColor: 'bg-cyan-100 text-cyan-700', title: 'アプリ開発サービスの提供を開始しました', body: 'iOS・Android対応のネイティブアプリ開発サービスを正式に開始いたしました。お気軽にご相談ください。', isImportant: false },
  { id: 5, date: '2023.07.06', category: '会社情報', categoryColor: 'bg-emerald-100 text-emerald-700', title: '株式会社Ocean 設立のお知らせ', body: '2023年7月6日、株式会社Oceanを設立いたしました。各種システム・ソフトウェアの開発・設計・配信、アプリ開発、Webサービス運営を主軸に事業を展開してまいります。', isImportant: false },
];

export default function NewsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="relative pt-32 pb-16 bg-gradient-to-br from-teal-900 to-cyan-800 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src="https://readdy.ai/api/search-image?query=abstract%20turquoise%20ocean%20wave%20pattern%20digital%20technology%20background%20minimal%20clean%20teal%20cyan%20gradient%20with%20geometric%20shapes&width=1920&height=400&seq=ocean-news-hero-01&orientation=landscape" alt="" className="w-full h-full object-cover object-top" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-teal-200 text-xs font-semibold uppercase tracking-widest mb-3">News</p>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>ニュース・お知らせ</h1>
          <p className="text-white/70 text-sm">株式会社Oceanからの最新情報をお届けします。</p>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <div className="space-y-4">
            {newsItems.map((item) => (
              <div key={item.id} className={`rounded-2xl border p-6 ${item.isImportant ? 'border-teal-300 bg-teal-50/40' : 'border-gray-100 bg-white'}`}>
                <div className="flex flex-wrap items-center gap-2 mb-3">
                  <span className="text-gray-400 text-xs">{item.date}</span>
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${item.categoryColor}`}>{item.category}</span>
                  {item.isImportant && <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-red-100 text-red-600">重要</span>}
                </div>
                <h2 className="text-base font-bold text-gray-900 mb-2">{item.title}</h2>
                <p className="text-sm text-gray-600 leading-relaxed">{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
